<template>
  <v-app>
    <!--
      -->
    <core-toolbar
      v-if="isLoggedIn"/>

    <core-drawer
      v-if="isLoggedIn"/>

    <core-view />

    <core-snackbar />
  </v-app>
</template>

<style lang="scss">
  @import '@/styles/index.scss';

  /* Remove in 1.2 */
  .v-datatable thead th.column.sortable i {
    vertical-align: unset;
  }
</style>

<script>
export default {
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
    }
  }
}
</script>
